const cantonNavigationContainer = document.querySelector('.canton-navigation-container');
const toggleNavigation = cantonNavigationContainer.querySelector('.toggle-canton-navigation');
const cantonNavigation = cantonNavigationContainer.querySelector('.canton-navigation');
const main = document.querySelector('main');
const cantonMapPreview = main.querySelector('.canton-map .canton-map-preview');

window.sfp = window.sfp || {};
window.sfp.openNavigation = function () {
    cantonNavigation.classList.remove('hidden');
    cantonNavigationContainer.classList.add('navigation-toggled');
    main.classList.add('navigation-toggled');

    if (cantonMapPreview) {
        cantonMapPreview.classList.add('hidden');
        document.body.classList.remove('preview-opened');

        window.sfp.closePreview();
    }
}

window.sfp.openPreview = function () {
    document.body.classList.add('preview-opened');
    cantonMapPreview.classList.remove('hidden');
    toggleNavigation.classList.remove('hidden');
    cantonNavigation.classList.add('hidden');
    cantonNavigationContainer.classList.remove('navigation-toggled');
    main.classList.remove('navigation-toggled');
}

window.sfp.closePreview = function () {
    document.body.classList.remove('preview-opened');
    cantonMapPreview.classList.add('hidden');
    toggleNavigation.classList.add('hidden');

    document.dispatchEvent(new Event('close-map-preview'));
}

toggleNavigation.addEventListener('click', window.sfp.openNavigation);

if (cantonMapPreview) {
    const closeSchweizMapPreview = cantonMapPreview.querySelector('.close-canton-map-preview');
    const openSchweizMapPreview = main.querySelector('.canton-map .canton-map-breadcrumb');

    closeSchweizMapPreview.addEventListener('click', window.sfp.openNavigation);
    openSchweizMapPreview.addEventListener('click', window.sfp.openPreview)
}
